// extracted by mini-css-extract-plugin
module.exports = {"DeliveryMapOptions":"DeliveryMapOptions_DeliveryMapOptions__3arje"};